<template>
  <div>
    <div class="agreement">
      <div class="page-wrap">
        <div class="page-headline"></div>
        <div class="page-content">
          <h5 class="agree-title">{{title}}</h5>
          <div class="agree-con"
               v-html="rules"></div>
        </div>
      </div>
      <p class="agree-wrap">
        <Checkbox v-model="agree">我已阅读并同意上述内容</Checkbox>
      </p>
      <button class="button-order"
              @click="agreeThisRule">同意</button>
    </div>
  </div>
</template>
<script>
import * as apis from '@/api/other'
export default {
  data () {
    return {
      rules: '',
      title: '',
      agree: false,
      id: 0,
      type: '',
    }
  },
  mounted () {
    let id = this.$route.params.hid;
    this.id = id;
    this.type = localStorage.getItem('hospital_type');
    this.getAgreementContent();
  },
  methods: {
    async getAgreementContent () {
      try {
        let data = {
          id: 1
        }
        let res = await apis.getUserAgreementsRuls(data);
        if (res.code == 200) {
          this.rules = res.data.content;
          this.title = res.data.name;
        }
      } catch (e) {
        console.log(e)
      }
    },
    agreeThisRule () {
      if (!this.agree) {
        this.$Message.error('您没有同意该协议，不能进行下一步！');
        return false;
      }
      // console.log(this.type)
      let type = this.type;
      if (type.indexOf('1') > -1) {
        this.$router.push({ name: 'Form', params: { hid: this.id } });
      } else if (type.indexOf('2') > -1) {
        this.$router.push({ name: 'FormOfOne', params: { hid: this.id } });
      } else if (type.indexOf('3') > -1) {
        this.$router.push({ name: 'FormOfTwo', params: { hid: this.id } });
      } else if (type.indexOf('4') > -1) {
        this.$router.push({ name: 'FormOfThree', params: { hid: this.id } });
      }

    },
  }
}
</script>
<style lang="less" scoped>
.page-wrap {
  width: 970px;
  background: #fff;
  border: 1px solid #dcdcdc;
  margin: 0 auto 30px;
  padding-bottom: 34px;
}
.page-headline {
  position: relative;
  width: 100%;
  height: 10px;
  background: #333130;
}
.page-headline::before {
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  width: 440px;
  height: 10px;
  background: #ae1e10;
  content: '';
}
.agree-title {
  font-size: 30px;
  color: #302e2e;
  line-height: 116px;
  text-align: center;
}
.agree-con {
  width: 860px;
  margin: 0 auto;
}
.button-order {
  width: 400px;
  border-radius: 4px;
  margin: 20px auto 54px;
}
.agree-wrap {
  width: 970px;
  margin: 0 auto;
  text-align: center;
}
</style>

